// @flow
import { LOCATION_CHANGE, push } from 'react-router-redux';

import { setSelectedFeature, setFitBounds } from 'actions/map';
import { setFollowedAircraft } from 'actions/rt';
import { showErrorMessage } from 'actions/errorMessage';
import { setSearchData } from 'actions/search';

import fetch from 'utils/fetch';

const ROUTE_RE = /\/(as|ap|s|ac)\/(.+)/;

export default store => next => action => {
  const { type, payload } = action;
  const { dispatch } = store;

  if (type === LOCATION_CHANGE) {
    const { pathname, state, hash } = payload;
    const match = pathname.match(ROUTE_RE);

    // mapbox-gl-js is set up to use the URL hash to store the current map
    // location. To allow copy-pasting URLs that include such information, we
    // only use panning when a hash is not present.
    const doPan = state ? !!payload.state.pan : !hash;

    if (match) {
      const [, endpoint, slug] = match;

      fetch(`/api/v1/${endpoint}/${slug}`)
        .then(response => response.json())
        .then(feature => {
          dispatch(
            setSelectedFeature({
              ...feature,
              type: endpoint,
            })
          );

          if (endpoint === 's') {
            dispatch(setSearchData(feature));
          }

          if (doPan && feature.bbox) {
            dispatch(setFitBounds(feature.bbox));
          } else if (endpoint === 'ac' && doPan) {
            // I think this fits the aircraft use case better than just panning
            dispatch(setFollowedAircraft(slug));
          }
        })
        .catch(() => {
          dispatch(showErrorMessage('A kért elem már nem érhető el.'));
          dispatch(push('/'));
        });
    } else {
      dispatch(setSelectedFeature(null));
    }
  }

  next(action);
};



// WEBPACK FOOTER //
// ./utils/mapFeature.middleware.js